// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.3_webpack@5.104.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@7.1.3_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -- Start slick conflicts fixes -- */
.entryscape .slick-prev, .entryscape .slick-next {
    font-size: 0px;
    line-height: 0px;
    color: transparent;
}
.entryscape .slick-prev:before, .entryscape .slick-next:before {
    color: black;
}
/* --- End of slick conflicts -- */

/* CSS of slider block */
.slider-nav .slick-track {
    height: 150px;
}

.slider-caption {
    line-height: initial;
    text-align: left;
}

.entryscape * {
    box-sizing: border-box;
}

/* Fix for popovers in wordpress. Override gutenberg-css for class "fade" that is used by bootstrap popovers */
.entryscape .fade {
    opacity: unset;
}

/* Override lighbox class from CMS environment (seems to stem from some bootstrap-based wordpress theme) */
body .lightbox {
    display: inherit;
    opacity: inherit;
    visibility: inherit;
}

/*-- Ugly css from commons --*/

.entryscape .entryList,
.entryscape .escoList {
    padding-bottom: 0px;
}

.entryscape .flex-wrapper,
.entryscape .entryName.vmiddle,
.entryscape .entryName.vmiddle>span {
    width: 100%
}

.screenreader__span{
    display: none;
}

.entryscape .panel {
    border-width: 0px;
}

/*--- Chartist make long names on x-axis break rather than overwrite each other --- */

.ct-chart-bar .ct-label.ct-horizontal.ct-end {
    word-break: break-all;
}

/*--- bootstrap-table.min.css add borders on tables in the wrong place when overflow-y ---*/
.entryscape .table-bordered {
    border: none;
}

.entryscape .fixed-table-body {
    border: 2px solid #dee2e6;
}

/*---Legend specific css below ---*/

.ct-chart-donut .ct-label, .ct-chart-pie .ct-label {
    font-size: large;
}

.ct-label {
    font-size: large;
    font-size: 16px;
    color: black;
}

.ct-legend {
    position: relative;
    z-index: 10;
    list-style: none;
    text-align: center;
    margin-top: 16px;
    overflow-y: auto;
    height: 100%;
}
.ct-legend li {
    position: relative;
    padding-left: 23px;
    margin-right: 10px;
    margin-bottom: 3px;
    cursor: pointer;
    display: inline-block;
}
.ct-legend li:before {
    width: 12px;
    height: 12px;
    position: absolute;
    left: 0;
    content: '';
    border: 3px solid transparent;
    border-radius: 2px;
    margin-top: 4px;
}
.ct-legend li.inactive:before {
    background: transparent;
}
.ct-legend.ct-legend-inside {
    position: absolute;
    top: 0;
    right: 0;
}
.ct-legend.ct-legend-inside li{
    display: block;
    margin: 0;
    text-align: left;
}
.ct-legend .ct-series-0:before {
    background-color: #d70206;
    border-color: #d70206;
}
.ct-legend .ct-series-1:before {
    background-color: #f05b4f;
    border-color: #f05b4f;
}
.ct-legend .ct-series-2:before {
    background-color: #f4c63d;
    border-color: #f4c63d;
}
.ct-legend .ct-series-3:before {
    background-color: #d17905;
    border-color: #d17905;
}
.ct-legend .ct-series-4:before {
    background-color: #453d3f;
    border-color: #453d3f;
}

.ct-legend .ct-series-5:before {
    background-color: #59922b;
    border-color: #59922b;
}

.ct-legend .ct-series-6:before {
    background-color: #0544d3;
    border-color: #0544d3;
}

.ct-legend .ct-series-7:before {
    background-color: #6b0392;
    border-color: #6b0392;
}

.ct-legend .ct-series-8:before {
    background-color: #f05b4f;
    border-color: #f05b4f;
}

.ct-legend .ct-series-9:before {
    background-color: #dda458;
    border-color: #dda458;
}

.ct-legend .ct-series-10:before {
    background-color: #eacf7d;
    border-color: #eacf7d;
}

.ct-legend .ct-series-11:before {
    background-color: #86797d;
    border-color: #86797d;
}

.ct-legend .ct-series-12:before {
    background-color: #b2c326;
    border-color: #b2c326;
}



/* @scazan: BOOTSTRAP FIXES FOR HIGHER SELECTORS: Bootstrap 3.3.7 */
/* TODO @scazan: This needs to be automated as it is currently manually maintained and extracted from bootstrap.css */

/* html { */
.entryscape {
  font-family: sans-serif;
  -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
}

/* html input[type="button"], */
/* input[type="reset"], */
/* input[type="submit"] { */
.entryscape input[type="button"] {
  -webkit-appearance: button;
  cursor: pointer;
}

/* html input[disabled] { */
.entryscape input[disabled] {
  cursor: default;
}

/* -- */
.selectize-dropdown .esbSearch {
    color: black;
    margin: 5px 0px;
    padding: 0px 1px;
    border: 1px solid white;
}
.selectize-dropdown .esbSearch {
    border-color: darkslategrey;
}
.selectize-dropdown *[data-selectable] {
    padding: 0px 12px;
    border: 1px solid white;
}
.selectize-dropdown *[data-selectable].active {
    border-color: darkslategrey;
}


.entryscape .selectize-control.single .selectize-input:after,
.entryscape .selectize-control.multi .selectize-input:after,
.entryscape .selectize-control.single .selectize-input.input-active:after,
.entryscape .selectize-control.multi .selectize-input.input-active:after {
    cursor: pointer;
    font-weight: 900;
    font-family: 'Font Awesome\\ 5 Free';
}


/* -- conflict in Linköping, with their theme and https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css --*/
.entryscape .fa.fa-external-link:before {
    content: "\\F08E";
}
.entryscape .form-group.searchBlockInner {
    padding: 0px;
    border: 0px;
}
body .entryscape .panel-heading .fa {
    color: rgb(51, 51, 51)!important;
}

.entryscape .entryList>.card {
    border: 0px;
}

.entryscape .entryList .card-header {
    padding: 0.75rem 1rem 0.75rem 0px;
}

.entryscape .entryList .lowerBlock .form-control {
    height: auto;
}

/* Break labels if they are too long in RDForms presentation form */
.compact.rdformsPresenter .rdformsTopLevel > .rdformsLabel {
    word-break: break-word;
}

/* Set display block on surrounding node to rdforms just to allow for correct size detection */
.esbRDFormsWrapper, .esbInlineDiv.esbRDFormsWrapper {
    display: block;
}

/* Tweaks on RDForms presentation */
.entryscape .compact .rdformsTopLevel.rdformsRow.notCompact>.rdformsFields>.rdformsGroup {
    margin: 2px 18px;
    padding: 10px 2px;
}
.entryscape .compact .rdformsRow.rdformsTopLevel .rdformsRow {
    padding: 0 0.7em;
}
.entryscape .rdformsPresenter .rdformsLabel {
    margin-bottom: 5px;
}

.entryscape .rdformsLabel {
    font-weight: normal;
    display: block;
}

.rdformsPresenter .rdformsLabel {
    border-bottom: 1px solid #E6E6E6;
}

.compact .rdformsRow>.rdformsFields>div {
    padding-left: 10px;
}

.compact .rdformsLabel {
    word-break: break-word;
    hyphens: auto;
}

.entryscape .rdformsField {
    margin-left: 0.6em;
    padding-right: 0.3em;
}
.entryscape .compact .rdformsTopLevel>.rdformsFields>.rdformsField {
    margin-left: 0.6em;
}

.entryscape .rdformsRow.rdformsTopLevel {
    padding-bottom: 0;
}

.rdformsPresenter .rdformsRow.rdformsTopLevel {
    width: 100%;
}

body .entryscape h2,
body .entryscape h3,
body .entryscape h4,
body .entryscape h5 {
margin-top: 20px;
}

body .entryscape .esbRowHead h2,
body .entryscape .esbRowHead h3,
body .entryscape .esbRowHead h4,
body .entryscape .esbRowHead h5 {
margin-top: 0px;
}

.entryscape .btn-link {
color: #005a9c;
}

.entryscape .btn-primary {
background-color: #005a9c;
border-color: #005a9c;
}

#entryscape_dialogs h3.popover-header,
.rdformsLabel h3.popover-header,
.rdformsField h3.popover-header,
.esbMapPopover h3.popover-header {
margin-top: 0;
}

.esbMapPopover .popover-body {
    max-height: 280px;
    overflow-y: auto;
    margin-bottom: 12px;
}

.esbMapPopover table {
    max-width: 100%;
}

@media screen and (min-width: 920px) {
    #entryscape_dialogs .rdformsRow.rdformsTopLevel {
        display: table;
    }
    #entryscape_dialogs .popover {
        max-width: 600px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/fixes.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,YAAY;AAChB;AACA,kCAAkC;;AAElC,wBAAwB;AACxB;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,8GAA8G;AAC9G;IACI,cAAc;AAClB;;AAEA,0GAA0G;AAC1G;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,8BAA8B;;AAE9B;;IAEI,mBAAmB;AACvB;;AAEA;;;IAGI;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,qFAAqF;;AAErF;IACI,qBAAqB;AACzB;;AAEA,2FAA2F;AAC3F;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mCAAmC;;AAEnC;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;AACA;IACI,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;;;AAIA,mEAAmE;AACnE,qHAAqH;;AAErH,WAAW;AACX;EACE,uBAAuB;EACvB,8BAA8B;MAC1B,0BAA0B;AAChC;;AAEA,+BAA+B;AAC/B,yBAAyB;AACzB,2BAA2B;AAC3B;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;;AAEA,OAAO;AACP;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,2BAA2B;AAC/B;;;AAGA;;;;IAII,eAAe;IACf,gBAAgB;IAChB,mCAAmC;AACvC;;;AAGA,kHAAkH;AAClH;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,YAAY;AAChB;;AAEA,mEAAmE;AACnE;IACI,sBAAsB;AAC1B;;AAEA,8FAA8F;AAC9F;IACI,cAAc;AAClB;;AAEA,mCAAmC;AACnC;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;;;;AAIA,gBAAgB;AAChB;;AAEA;;;;AAIA,eAAe;AACf;;AAEA;AACA,cAAc;AACd;;AAEA;AACA,yBAAyB;AACzB,qBAAqB;AACrB;;AAEA;;;;AAIA,aAAa;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["/* -- Start slick conflicts fixes -- */\n.entryscape .slick-prev, .entryscape .slick-next {\n    font-size: 0px;\n    line-height: 0px;\n    color: transparent;\n}\n.entryscape .slick-prev:before, .entryscape .slick-next:before {\n    color: black;\n}\n/* --- End of slick conflicts -- */\n\n/* CSS of slider block */\n.slider-nav .slick-track {\n    height: 150px;\n}\n\n.slider-caption {\n    line-height: initial;\n    text-align: left;\n}\n\n.entryscape * {\n    box-sizing: border-box;\n}\n\n/* Fix for popovers in wordpress. Override gutenberg-css for class \"fade\" that is used by bootstrap popovers */\n.entryscape .fade {\n    opacity: unset;\n}\n\n/* Override lighbox class from CMS environment (seems to stem from some bootstrap-based wordpress theme) */\nbody .lightbox {\n    display: inherit;\n    opacity: inherit;\n    visibility: inherit;\n}\n\n/*-- Ugly css from commons --*/\n\n.entryscape .entryList,\n.entryscape .escoList {\n    padding-bottom: 0px;\n}\n\n.entryscape .flex-wrapper,\n.entryscape .entryName.vmiddle,\n.entryscape .entryName.vmiddle>span {\n    width: 100%\n}\n\n.screenreader__span{\n    display: none;\n}\n\n.entryscape .panel {\n    border-width: 0px;\n}\n\n/*--- Chartist make long names on x-axis break rather than overwrite each other --- */\n\n.ct-chart-bar .ct-label.ct-horizontal.ct-end {\n    word-break: break-all;\n}\n\n/*--- bootstrap-table.min.css add borders on tables in the wrong place when overflow-y ---*/\n.entryscape .table-bordered {\n    border: none;\n}\n\n.entryscape .fixed-table-body {\n    border: 2px solid #dee2e6;\n}\n\n/*---Legend specific css below ---*/\n\n.ct-chart-donut .ct-label, .ct-chart-pie .ct-label {\n    font-size: large;\n}\n\n.ct-label {\n    font-size: large;\n    font-size: 16px;\n    color: black;\n}\n\n.ct-legend {\n    position: relative;\n    z-index: 10;\n    list-style: none;\n    text-align: center;\n    margin-top: 16px;\n    overflow-y: auto;\n    height: 100%;\n}\n.ct-legend li {\n    position: relative;\n    padding-left: 23px;\n    margin-right: 10px;\n    margin-bottom: 3px;\n    cursor: pointer;\n    display: inline-block;\n}\n.ct-legend li:before {\n    width: 12px;\n    height: 12px;\n    position: absolute;\n    left: 0;\n    content: '';\n    border: 3px solid transparent;\n    border-radius: 2px;\n    margin-top: 4px;\n}\n.ct-legend li.inactive:before {\n    background: transparent;\n}\n.ct-legend.ct-legend-inside {\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n.ct-legend.ct-legend-inside li{\n    display: block;\n    margin: 0;\n    text-align: left;\n}\n.ct-legend .ct-series-0:before {\n    background-color: #d70206;\n    border-color: #d70206;\n}\n.ct-legend .ct-series-1:before {\n    background-color: #f05b4f;\n    border-color: #f05b4f;\n}\n.ct-legend .ct-series-2:before {\n    background-color: #f4c63d;\n    border-color: #f4c63d;\n}\n.ct-legend .ct-series-3:before {\n    background-color: #d17905;\n    border-color: #d17905;\n}\n.ct-legend .ct-series-4:before {\n    background-color: #453d3f;\n    border-color: #453d3f;\n}\n\n.ct-legend .ct-series-5:before {\n    background-color: #59922b;\n    border-color: #59922b;\n}\n\n.ct-legend .ct-series-6:before {\n    background-color: #0544d3;\n    border-color: #0544d3;\n}\n\n.ct-legend .ct-series-7:before {\n    background-color: #6b0392;\n    border-color: #6b0392;\n}\n\n.ct-legend .ct-series-8:before {\n    background-color: #f05b4f;\n    border-color: #f05b4f;\n}\n\n.ct-legend .ct-series-9:before {\n    background-color: #dda458;\n    border-color: #dda458;\n}\n\n.ct-legend .ct-series-10:before {\n    background-color: #eacf7d;\n    border-color: #eacf7d;\n}\n\n.ct-legend .ct-series-11:before {\n    background-color: #86797d;\n    border-color: #86797d;\n}\n\n.ct-legend .ct-series-12:before {\n    background-color: #b2c326;\n    border-color: #b2c326;\n}\n\n\n\n/* @scazan: BOOTSTRAP FIXES FOR HIGHER SELECTORS: Bootstrap 3.3.7 */\n/* TODO @scazan: This needs to be automated as it is currently manually maintained and extracted from bootstrap.css */\n\n/* html { */\n.entryscape {\n  font-family: sans-serif;\n  -webkit-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n}\n\n/* html input[type=\"button\"], */\n/* input[type=\"reset\"], */\n/* input[type=\"submit\"] { */\n.entryscape input[type=\"button\"] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n\n/* html input[disabled] { */\n.entryscape input[disabled] {\n  cursor: default;\n}\n\n/* -- */\n.selectize-dropdown .esbSearch {\n    color: black;\n    margin: 5px 0px;\n    padding: 0px 1px;\n    border: 1px solid white;\n}\n.selectize-dropdown .esbSearch {\n    border-color: darkslategrey;\n}\n.selectize-dropdown *[data-selectable] {\n    padding: 0px 12px;\n    border: 1px solid white;\n}\n.selectize-dropdown *[data-selectable].active {\n    border-color: darkslategrey;\n}\n\n\n.entryscape .selectize-control.single .selectize-input:after,\n.entryscape .selectize-control.multi .selectize-input:after,\n.entryscape .selectize-control.single .selectize-input.input-active:after,\n.entryscape .selectize-control.multi .selectize-input.input-active:after {\n    cursor: pointer;\n    font-weight: 900;\n    font-family: 'Font Awesome\\ 5 Free';\n}\n\n\n/* -- conflict in Linköping, with their theme and https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css --*/\n.entryscape .fa.fa-external-link:before {\n    content: \"\\F08E\";\n}\n.entryscape .form-group.searchBlockInner {\n    padding: 0px;\n    border: 0px;\n}\nbody .entryscape .panel-heading .fa {\n    color: rgb(51, 51, 51)!important;\n}\n\n.entryscape .entryList>.card {\n    border: 0px;\n}\n\n.entryscape .entryList .card-header {\n    padding: 0.75rem 1rem 0.75rem 0px;\n}\n\n.entryscape .entryList .lowerBlock .form-control {\n    height: auto;\n}\n\n/* Break labels if they are too long in RDForms presentation form */\n.compact.rdformsPresenter .rdformsTopLevel > .rdformsLabel {\n    word-break: break-word;\n}\n\n/* Set display block on surrounding node to rdforms just to allow for correct size detection */\n.esbRDFormsWrapper, .esbInlineDiv.esbRDFormsWrapper {\n    display: block;\n}\n\n/* Tweaks on RDForms presentation */\n.entryscape .compact .rdformsTopLevel.rdformsRow.notCompact>.rdformsFields>.rdformsGroup {\n    margin: 2px 18px;\n    padding: 10px 2px;\n}\n.entryscape .compact .rdformsRow.rdformsTopLevel .rdformsRow {\n    padding: 0 0.7em;\n}\n.entryscape .rdformsPresenter .rdformsLabel {\n    margin-bottom: 5px;\n}\n\n.entryscape .rdformsLabel {\n    font-weight: normal;\n    display: block;\n}\n\n.rdformsPresenter .rdformsLabel {\n    border-bottom: 1px solid #E6E6E6;\n}\n\n.compact .rdformsRow>.rdformsFields>div {\n    padding-left: 10px;\n}\n\n.compact .rdformsLabel {\n    word-break: break-word;\n    hyphens: auto;\n}\n\n.entryscape .rdformsField {\n    margin-left: 0.6em;\n    padding-right: 0.3em;\n}\n.entryscape .compact .rdformsTopLevel>.rdformsFields>.rdformsField {\n    margin-left: 0.6em;\n}\n\n.entryscape .rdformsRow.rdformsTopLevel {\n    padding-bottom: 0;\n}\n\n.rdformsPresenter .rdformsRow.rdformsTopLevel {\n    width: 100%;\n}\n\nbody .entryscape h2,\nbody .entryscape h3,\nbody .entryscape h4,\nbody .entryscape h5 {\nmargin-top: 20px;\n}\n\nbody .entryscape .esbRowHead h2,\nbody .entryscape .esbRowHead h3,\nbody .entryscape .esbRowHead h4,\nbody .entryscape .esbRowHead h5 {\nmargin-top: 0px;\n}\n\n.entryscape .btn-link {\ncolor: #005a9c;\n}\n\n.entryscape .btn-primary {\nbackground-color: #005a9c;\nborder-color: #005a9c;\n}\n\n#entryscape_dialogs h3.popover-header,\n.rdformsLabel h3.popover-header,\n.rdformsField h3.popover-header,\n.esbMapPopover h3.popover-header {\nmargin-top: 0;\n}\n\n.esbMapPopover .popover-body {\n    max-height: 280px;\n    overflow-y: auto;\n    margin-bottom: 12px;\n}\n\n.esbMapPopover table {\n    max-width: 100%;\n}\n\n@media screen and (min-width: 920px) {\n    #entryscape_dialogs .rdformsRow.rdformsTopLevel {\n        display: table;\n    }\n    #entryscape_dialogs .popover {\n        max-width: 600px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
